export const useUtm = () => {
    function getKeyByValue(value: string) {
        const utmObject = JSON.parse(localStorage.getItem("utm") as string);
        if (utmObject) {
            return Object.keys(utmObject).find((key) => {
                return key === value;
            });
        }
    }

    const setUtm = () => {
        const { query, path } = useRoute();
        const { utm_adgroup, utm_campaign, utm_medium, utm_source, utm_term, via } = query;
        const utmObject = JSON.parse(localStorage.getItem("utm") as string);

        const rewardfulReferral = useCookie<{ id: string }>("rewardful.referral");
        const utmItems: IUtmItems = {
            utm_adgroup: getKeyByValue("utm_adgroup") ? utmObject.utm_adgroup : utm_adgroup,
            utm_campaign: getKeyByValue("utm_campaign") ? utmObject.utm_campaign : utm_campaign,
            utm_medium: getKeyByValue("utm_medium") ? utmObject.utm_medium : utm_medium,
            utm_source: getKeyByValue("utm_source") ? utmObject?.utm_source : utm_source,
            utm_term: getKeyByValue("utm_term") ? utmObject?.utm_term : utm_term,
            utm_from_url: path,
        };
        via ? (utmItems["via"] = `${via}${rewardfulReferral.value ? "," + rewardfulReferral.value.id : ""}`) : {};

        localStorage.setItem("utm", JSON.stringify(utmItems));
    };

    const getUtm = (payload: any) => {
        const utmObject: IUtmItems = JSON.parse(localStorage.getItem("utm") as string);
        payload["via"] = utmObject?.via ?? "Not Set";
        payload["utm_campaign"] = utmObject?.utm_campaign ?? "Not Set";
        payload["utm_source"] = utmObject?.utm_source ?? "Not Set";
        payload["utm_medium"] = utmObject?.utm_medium
            ? utmObject.utm_medium
            : document.referrer === "https://www.google.com/"
            ? "organic"
            : "Not Set";
        payload["utm_adgroup"] = utmObject?.utm_adgroup ?? "Not Set";
        payload["utm_term"] = utmObject?.utm_term ?? "Not Set";
        payload["utm_from_url"] = utmObject?.utm_from_url ?? "Not Set";
        return payload;
    };

    return { setUtm, getUtm };
};
